import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InventoryComponent } from '../../shared/inventory/inventory.component';
import { ListPublisherUserComponent } from '../../shared/publisher-user/list-publisher-user/list-publisherUser.component';
import { InventorySharedModule } from '../../shared/inventory/inventory.shared.module';
import { ListUserGroupComponent } from '../../shared/user-group/list-user-group/list-user-group.component';

@NgModule({
    imports: [FormsModule, CommonModule, RouterModule, InventorySharedModule],
    declarations: [
        ListUserGroupComponent,
        ListPublisherUserComponent,
        InventoryComponent
    ],
    providers: [],
    exports: [
        ListUserGroupComponent,
        ListPublisherUserComponent,
        InventoryComponent
    ]
})
export class PublisherDetailSharedModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/owner/publisher-detail/publisher-detail.shared.module.ts